import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';

export const deleteData = (slice: any, url: string) => (item: string) => async (dispatch: any) => {
	// dispatch(slice.actions.fetchDataStart());

	try {
		const requestUrl = `${url}${item}`;
		const response = await apiUrl.delete(requestUrl);

		if (response.status === 200) {
			dispatch(slice.actions.deleteDataSuccess(item));
			return true;
		}
	} catch (error) {
		handleResponseError(error, (errorMessage, isNetworkError) => {
			dispatch(slice.actions.fetchDataError({ errorMessage, isNetworkError }));
		});
		return false;
	}
};
